import type { SVGProps } from 'react'
const SvgSave = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="save_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#save_svg__a)">
      <path d="M15.902 5.187v9.01q0 .707-.498 1.207a1.65 1.65 0 0 1-1.208.498H3.804q-.708 0-1.208-.498a1.65 1.65 0 0 1-.498-1.208V3.804q0-.708.498-1.208a1.65 1.65 0 0 1 1.208-.498h9.009zm-1.706.723L12.09 3.804H3.804v10.392h10.392zM9 13.446a2.17 2.17 0 0 0 1.594-.656 2.17 2.17 0 0 0 .656-1.594 2.17 2.17 0 0 0-.656-1.594A2.17 2.17 0 0 0 9 8.946a2.17 2.17 0 0 0-1.594.656 2.17 2.17 0 0 0-.656 1.594q0 .937.656 1.594A2.17 2.17 0 0 0 9 13.446M4.554 7.554h6.75v-3h-6.75z" />
    </g>
  </svg>
)
export default SvgSave
